import React from 'react';
import classNames from 'classnames';
import PropTypes, { node } from 'prop-types';
import keycode from 'keycode';
import { connect } from "react-redux";
import TableFooter from '@material-ui/core/TableFooter';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import FilterListIcon from 'material-ui-icons/FilterList';

let counter = 0;

const alertType = [
    { status: 'Closed' },
    { status: 'Open' },
    { status: 'In Progress' },
];

const columnData = [
    { id: 'nodeId', numeric: false, disablePadding: true, label: 'Device ID', type: 'string' },
    { id: 'time', numeric: false, disablePadding: false, label: 'Time', type: 'date' },
    { id: 'event', numeric: false, disablePadding: false, label: 'Event Type', type: 'string' },
    { id: 'eventVal', numeric: false, disablePadding: true, label: 'Event Value', type: 'string' },
    { id: 'dataValue', numeric: true, disablePadding: false, label: 'Alert Value', type: 'number' },
    { id: 'threshold', numeric: true, disablePadding: false, label: 'Threshold', type: 'number' },
    { id: 'alertStatus', numeric: false, disablePadding: false, label: 'Alert Status', type: 'string' },
    { id: 'ticketNumber', numeric: false, disablePadding: false, label: 'Ticket#', type: 'string' },
];

class EnhancedTableHead extends React.Component {
    static propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {/* <TableCell padding="checkbox">
                        <Checkbox color="primary"
                                  indeterminate={numSelected > 0 && numSelected < rowCount}
                                  checked={numSelected === rowCount}
                                  onChange={onSelectAllClick}
                        />
                    </TableCell> */}
                    {columnData.map(column => {
                        return (
                            <TableCell
                                style={{
                                    background: '#E2E3E5'
                                }}
                                className={column.id !== 'deviceId' && "text-center"}
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'default'}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}


let EnhancedTableToolbar = props => {
    const { numSelected } = props;

    return (
        <Toolbar
            className={classNames("table-header", {
                ["highlight-light"]: numSelected > 0,
            })}
        >
            <div className="title">
                <Typography type="title">Add Filter</Typography>
            </div>
            <div className="actions">
                {numSelected > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                ) : (
                        <Tooltip title="Filter list">
                            <IconButton aria-label="Filter list">
                                <FilterListIcon onClick={() => { props.openModal(); }} />
                            </IconButton>
                        </Tooltip>
                    )}
            </div>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};


class EnhancedTable extends React.Component {
    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';
        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        let data = [];
        data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));
        this.setState({ data, order, orderBy });
    };
    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({ selected: this.state.data.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };
    handleKeyDown = (event, id) => {
        if (keycode(event) === 'space') {
            this.handleClick(event, id);
        }
    };
    handleClick = (event, deviceId) => {
        this.props.updateDeviceId(deviceId);
        // const { selected } = this.state;
        // const selectedIndex = selected.indexOf(id);
        // let newSelected = [];

        // if (selectedIndex === -1) {
        //     newSelected = newSelected.concat(selected, id);
        // } else if (selectedIndex === 0) {
        //     newSelected = newSelected.concat(selected.slice(1));
        // } else if (selectedIndex === selected.length - 1) {
        //     newSelected = newSelected.concat(selected.slice(0, -1));
        // } else if (selectedIndex > 0) {
        //     newSelected = newSelected.concat(
        //         selected.slice(0, selectedIndex),
        //         selected.slice(selectedIndex + 1),
        //     );
        // }

        // this.setState({ selected: newSelected });
    };
    handleChangePage = (event, page) => {
        // this.setState({ page });
        this.props.updateFilterAlertModification({
            data: this.state.data,
            pageNumber: page,
        })
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    constructor(props, context) {
        super(props, context);
        this.state = {
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            data: props.alertModificationFilter.data,
            page: props.alertModificationFilter.pageNumber,
            filterData: props.alertModification.data,
            rowsPerPage: 25,
            selectedIndex: null,
        };
    }

    setData(data) {
        this.setState({
            data: data.alertModificationFilter.data,
            page: data.alertModificationFilter.pageNumber,
            filterData: data.alertModification.data
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setData(nextProps);
    }

    checkWaterLevel = (threshold, water) => {
        let waterLevel = threshold.data && threshold.data.thresholds && threshold.data.thresholds.water;
        if (water < (waterLevel && waterLevel.min) || water > (waterLevel && waterLevel.max)) {
            return true;
        }
        return false;
    }

    checkTemperatureThreshold = (threshold, temperature) => {
        let temperatureThreshold = threshold.data && threshold.data.thresholds && threshold.data.thresholds.temperature;
        if (temperature < (temperatureThreshold && temperatureThreshold.min) || temperature > (temperatureThreshold && temperatureThreshold.max)) {
            return true;
        }
        return false;
    }

    checkCurrentThreshold = (threshold, current) => {
        if (current < threshold && threshold.min || current > threshold && threshold.max) {
            return true;
        }
        return false;
    }

    getdeviceOnline = (status) => {
        if (status === "ACTIVE") {
            return <img
                className="statusImage d-inline-block mx-2 pl-0"
                src="../../../../assets/images/online.png"
                alt="Online"
                style={{
                    borderRadius: 15,
                }}
            />;
        } else if (status === "INACTIVE") {
            return <img
                className="statusImage d-inline-block mx-2 pl-0"
                src="../../../../assets/images/redIc.png"
                alt="Offline"
                style={{
                    borderRadius: 15,
                }}
            />;
        }
        return <img
            className="statusImage d-inline-block mx-2 pl-0"
            src="../../../../assets/images/offline.png"
            alt="Offline"
            style={{
                borderRadius: 15,
            }}
        />;
    };

    handleSelectStatus = (item, nodeData) => {
        let data = {
            alertStatus: item.target.value,
            time: nodeData.time
        }
        this.props.updateAlertStatus(data, nodeData.nodeId);
    }

    handleInput = (index, n) => {
        this.setState({
            selectedIndex: {
                n,
                index
            }
        })
    }
    formatDate(date) {
        const updatedTime = `${new Date(date * 1000).getFullYear()}-${(
            "0" +
            (new Date(date * 1000).getMonth() + 1)
        ).substr(-2)}-${("0" + new Date(date * 1000).getDate()).substr(-2)}, ${(
            "0" + new Date(date * 1000).getHours()
        ).substr(-2)}:${("0" + new Date(date * 1000).getMinutes()).substr(-2)}:${(
            "0" + new Date(date * 1000).getSeconds()
        ).substr(-2)}`;
        return updatedTime;
    }


    render() {
        const { data, filterData, order, orderBy, selected, rowsPerPage, page, selectedIndex } = this.state;
        let filteredData = [];
        filterData.map((n, index) => {
            const isSelected = this.isSelected(n.id);
            const time = this.formatDate(n.time);
            const event = n.event;
            const eventVal = n.eventVal;
            const dataValue = n.dataValue;
            const threshold = n.threshold;
            const alertStatus = n.alertStatus;
            let ticketNumber = n.ticketNumber;
            filteredData.push({
                id: index,
                n,
                nodeId: n.nodeId,
                time,
                event,
                eventVal,
                dataValue,
                threshold,
                alertStatus,
                ticketNumber
            })
        });
        return (
            <div className="w-100 px-2 device-catalogue">
                <EnhancedTableToolbar openModal={() => {
                    $("#searchModalComponent").modal();
                    this.props.passDataForFilter({ filteredData, columnData });
                }} />
                <div className="flex-auto"
                    style={{
                        background: 'white'
                    }}>
                    <TableContainer className="table-responsive-material"
                        style={{
                            maxHeight: window.innerHeight - 300,
                        }}
                    >
                        <Table stickyHeader>
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleRequestSort}
                                rowCount={data.length}
                            />
                            <TableBody>
                                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => {
                                    const n = item.n ? item.n : item;
                                    const isSelected = this.isSelected(n.id);
                                    const time = this.formatDate(n.time);
                                    const event = n.event;
                                    const eventVal = n.eventVal;
                                    const dataValue = n.dataValue;
                                    const threshold = n.threshold;
                                    const alertStatus = n.alertStatus;
                                    let ticketNumber = n.ticketNumber;

                                    return (
                                        <TableRow
                                            hover
                                            // onClick={event => this.handleClick(event, n.nodeId)}
                                            // onKeyDown={event => this.handleKeyDown(event, n.nodeId)}
                                            role="checkbox"
                                            aria-checked={isSelected}
                                            tabIndex={-1}
                                            key={n.id}
                                            selected={isSelected}
                                        >
                                            {/* <TableCell padding="checkbox">
                                                <Checkbox color="primary" checked={isSelected} />
                                            </TableCell> */}
                                            <TableCell padding="none"
                                            onClick={event => this.handleClick(event, n.nodeId)}
                                            onKeyDown={event => this.handleKeyDown(event, n.nodeId)}
                                            id="deviceId"
                                            >{n.nodeId}</TableCell>
                                            <TableCell className="text-center">
                                                {time}
                                            </TableCell>
                                            <TableCell className="text-center">
                                                {event}
                                            </TableCell>
                                            <TableCell className="text-center">
                                                {eventVal}
                                            </TableCell>
                                            <TableCell className="text-center">
                                                {dataValue}
                                            </TableCell>
                                            <TableCell className="text-center">
                                                {threshold}
                                            </TableCell>
                                            <TableCell className="text-center">
                                                <select className="border-0" name="alertStatus" id="alertStatus" onChange={(item) => this.handleSelectStatus(item, n)}>
                                                    <option value="none" disabled>
                                                        Select an Status</option>
                                                    {alertType.map((item) => {
                                                        return (<option value={item.status} selected={alertStatus === item.status}>{item.status}</option>);
                                                    })}
                                                </select>
                                            </TableCell>
                                            <TableCell className="text-center" onClick={event => this.handleInput(index, n)}>
                                                {index === (selectedIndex !== null && selectedIndex.index) ? <input
                                                    className="border-0"
                                                    type="text"
                                                    placeholder=""
                                                    onBlur={(event) => {
                                                        if (event.target.value !== '') {
                                                            let data = {
                                                                ticketNumber: event.target.value,
                                                                time: n.time
                                                            }
                                                            this.setState({
                                                                selectedIndex: null,
                                                            })
                                                            this.props.updateAlertStatus(data, n.nodeId);
                                                        }
                                                    }}
                                                    onChange={(event) => {
                                                        let n = selectedIndex.n;
                                                        n.ticketNumber = event.target.value;
                                                        this.setState({
                                                            selectedIndex: {
                                                                n,
                                                                index: selectedIndex.index
                                                            }
                                                        })
                                                    }}
                                                    value={selectedIndex.n.ticketNumber}
                                                /> : ticketNumber}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        style={{
                            width: window.innerWidth,
                        }}
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                </div>
            </div>
        );
    }
}



const mapStateToProps = ({ symbioticReducer }) => {
    return {
        deviceId: symbioticReducer.deviceId,
        alertModification: symbioticReducer.alertModification,
        alertModificationFilter : symbioticReducer.alertModificationFilter,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateAlertModification: (data) => {
            dispatch({ type: "ALERT_MODIFICATION_DATA", alertModification: data });
        },
        updateFilterAlertModification: (data) => {
            dispatch({ type: "ALERT_MODIFICATION_FILTER_DATA", alertModification: data });
          },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EnhancedTable);



// WEBPACK FOOTER //
// ./app/routes/alertModification/EnhancedTable.js